import React, { useEffect } from "react";
import BankWrapper from "../../layout/BankWrapper";
import TransfereeWrapper from "../../layout/TransfereeWrapper";
import NotapWrapper from "../../layout/NotapWrapper";
import { useDispatch, useSelector } from "react-redux";
import CardSummary from "./CardSummary";
import { DataTableWrapper } from "../../components";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearAll,
  clearResetBot,
  onGetHistory,
  setCertificateDetailsGeneral,
  setErrorMessageUser,
  setLoadingUser,
} from "../../../config/redux/slice/appSlice";
import { historyDatatable } from "../../../helpers/dataTables";
import { getRequest, postRequest } from "../../../helpers/request";
import { appApi } from "../../../utils/endpoints/appApi";
import { appUrls } from "../../../utils/urls/appUrls";
import $ from "jquery";

export default function TransactionHistory() {
  const { certificateNo } = useParams();
  const {
    token,
    userData: { user_role },
  } = useSelector((state) => state.authData);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currencies } = useSelector((state) => state.app);
  const {
    userLoading,
    userErrorMsg,
    userSuccessMsg,
    certificateManagement: {
      certificatesData,
      certificateDetails,
      showUploadSuccessModal,
      newData,
      showCertificateForm,
      showResendLinkConfirmation,
    },
  } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(clearAll({}));
    // dispatch(setCertificateDetailsGeneral({details: '', modal: false}))
    // historyDatatable(certificatesData, setDetails, currencies);
    getAllHistory();
  }, []);

  const getAllHistory = async () => {
    dispatch(clearAll({}));
    // const data = {
    //   certificate_date: "0",
    //   issuer: "0",
    //   verification_status: "all"
    // }
    const certificateNumber =
      certificateDetails?.CERTIFICATE_NUMBER ?? certificateNo;
    const res = await getRequest(
      token,
      `${appApi.getHistory(certificateNumber)}`,
      {},
      dispatch,
      setLoadingUser,
      onGetHistory,
      setErrorMessageUser,
    );
    //   if(res !== undefined && res.status < 400){
    //       setBanks(res.data.data)
    //   }
  };

  console.log("HISTORY DATA:", certificatesData);

  const setDetails = (data, type) => {
    if (type == "view-details") {
      dispatch(setCertificateDetailsGeneral({ details: data, modal: true }));
      navigate(appUrls.certificates_view);
    }
  };

  useEffect(() => {
    if (newData && certificatesData?.length > 0) {
      // if ($.fn.DataTable.isDataTable("#historyTable")) {
      //   $("#historyTable").DataTable().clear().destroy();
      // }
      historyDatatable(certificatesData, setDetails, currencies);
      dispatch(clearResetBot());
    }
    // if(userSuccessMsg==='Certificate Uploaded Successfully'){
    //       getAllHistory()
    // }
  }, [newData, userSuccessMsg, certificatesData, currencies]);

  return (
    <>
      {user_role == "BANK_USER" ? (
        <BankWrapper pageTitle={"Certificate History"}>
          <WrapperChildren historyList={certificatesData} />
        </BankWrapper>
      ) : user_role == "TRANSFEREE_USER" ? (
        <TransfereeWrapper pageTitle={"Certificate History"}>
          <WrapperChildren historyList={certificatesData} />
        </TransfereeWrapper>
      ) : (
        <NotapWrapper pageTitle={"Certificate History"}>
          <WrapperChildren historyList={certificatesData} />
        </NotapWrapper>
      )}
    </>
  );
}

function WrapperChildren({ historyList }) {
  // const {
  //       userLoading,
  //       userErrorMsg,
  //       userSuccessMsg,
  //       certificateManagement:{certificatesData, certificateDetails, showUploadSuccessModal, newData, showCertificateForm, showResendLinkConfirmation}
  //   } = useSelector((state) => state.app)
  return (
    <div>
      {/* <CardSummary historyList={historyList} /> */}
      <DataTableWrapper tableID="historyTable" tableName="History">
        <thead>
          <tr>
            <th>Reference ID</th>
            <th>Certificate Issue Date</th>
            <th>Currency</th>
            <th>Amount Requested</th>
            <th>Approved Amount</th>
            <th>WHT Rate</th>
            <th>Amount Available</th>
            <th>Balance</th>
            <th>Contact Name</th>
            <th>Contact Email</th>
            <th>Contact Phone</th>
            {/* <th>Comment</th> */}
            <th>Status</th>

            <th>Date</th>
            {/* <th width={'9%'}  data-orderable="false">Action</th> */}
          </tr>
        </thead>
        <tbody></tbody>
      </DataTableWrapper>
    </div>
  );
}
